<template>
  <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
    <div slot="content">
      <el-form size="mini" :model="form" ref="catInfoForm" class="components">
        <el-row>
          <el-col>
            <el-col :span="6">
              <el-form-item label="의뢰번호">
                <el-input v-model="form.requestId" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="의뢰일자">
                <el-date-picker type="date" placeholder="Pick a date" v-model="form.requestDt" style="width: 100%;" value-format="yyyy-MM-dd" disabled></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="의뢰자" prop="catNm">
                <el-input v-model="form.requestNm" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="설치완료요청일">
                <el-date-picker type="date" placeholder="Pick a date" v-model="form.requestSetupDt" style="width: 100%;" value-format="yyyy-MM-dd" disabled></el-date-picker>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-col :span="4">
              <el-form-item label="영업부서">
                <el-input v-model="form.saleDeptNm" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="영업담당">
                <el-input v-model="form.saleChargeNm" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="설치처명">
                <el-input v-model="form.saleDeptNm" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="설치기사">
                <el-select v-model="form.agentUser">
                  <el-option value='0' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['agentUser']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-col :span="24">
              <el-form-item label="주소">
                <el-input v-model="form.addr" disabled></el-input>
              </el-form-item>
            </el-col>
<!--            <el-col :span="4">-->
<!--              <el-form-item label="주소">-->
<!--                <el-input v-model="form.zipCd" disabled></el-input>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--            <el-col :span="10">-->
<!--              <el-form-item label=" ">-->
<!--                <el-input v-model="form.addr1" disabled></el-input>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--            <el-col :span="10">-->
<!--              <el-form-item label=" ">-->
<!--                <el-input v-model="form.addr2" disabled></el-input>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="사이트명">
              <el-row>
                <el-col :span="24">
                  <el-col :span="8">
                    <el-input type="text" v-model="form.siteNm1" disabled></el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input type="text" v-model="form.siteNm2" disabled></el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input type="text" v-model="form.siteNm3" disabled></el-input>
                  </el-col>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-col :span="8">
              <el-form-item label="고객명">
                <el-input v-model="form.chargeNm" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="전화번호">
                <el-input v-model="form.telNo" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="휴대폰">
                <el-input v-model="form.hpNo" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>

        <el-row class="demo-autocomplete" >
          <el-col :span="24">
            <el-form-item label="설치시 유의사항">
              <el-input
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 5}"
                  placeholder="유의사항을 작성하세요."
                  v-model="form.memo">
              </el-input>
            </el-form-item>
            <div class="grid-content bg-purple"></div>
          </el-col>
        </el-row>
      </el-form>

      <div class="table-area" style="width: 100%; display: flex;">

        <div class="table-b" style="width: 45%; margin-right: 5%;">
          <div class="table-header">
            <div class="table-name">
              <h3 class="ico_table_name">{{ `설치의뢰 내역` }}</h3>
            </div>
            <div class="grid-tbl-box">
              <ag-grid-vue
                  ref="grid"
                  :style="gridStyle"
                  class="ag-theme-alpine"
                  :enableRangeSelection="true"
                  :column-defs="columnDefs"
                  :grid-options="mainGridOptions"
                  :row-data="mainData"
                  :default-col-def="defaultColDef"
                  :framework-components="frameworkComponent"
                  @grid-ready="onReadyMain"/>
            </div>
          </div>
        </div>

        <div class="table-b" style="width: 50%;">
          <div class="table-name">
            <h3 class="ico_table_name">{{ `설치비` }}</h3>
          </div>
          <el-form size="mini" :model="form" ref="catInfoForm" class="components">
            <el-row>
              <el-col>
                <el-col :span="12">
                  <el-form-item label="설치비(1)">
                    <el-input v-model="form.setupUnitPrice1" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="설치비(2)">
                    <el-input v-model="form.setupUnitPrice2" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-col :span="12">
                  <el-form-item label="원거리출장비" prop="catNm">
                    <el-input v-model="form.setupEtcPrice1" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="기타비용" prop="catNm">
                    <el-input v-model="form.setupEtcPrice2" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="합계" prop="catNm">
                  <el-input v-model="form.setupAmt" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>

      <div class="table-area">

        <div class="table-b">
          <div class="table-header">
            <div class="table-name">
              <h3 class="ico_table_name">{{ `설치 내역` }}</h3>
            </div>
            <div class="grid-tbl-box">
              <ag-grid-vue
                  ref="gridSub"
                  :style="gridStyle"
                  class="ag-theme-alpine"
                  row-selection="single"
                  :column-defs="subColumnDefs"
                  :grid-options="subGridOptions"
                  :row-data="subData"
                  :default-col-def="defaultColDef"
                  :statusBar="statusBar"
                  :framework-components="frameworkComponent"
                  @grid-ready="onReadyMain"/>
            </div>
          </div>
        </div>


        <div v-if="showForm" class="table-b">
          <div class="table-name">
            <h3 class="ico_table_name">{{ `기타설치결과` }}</h3>
          </div>
          <el-form v-if="showForm" size="mini" :model="form" ref="catInfoForm" class="components">
            <el-row class="demo-autocomplete" >
              <el-col :span="24">
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 5}"
                    placeholder="설치결과를 작성하세요."
                    v-model="form.setupResult">
                </el-input>
                <div class="grid-content bg-purple"></div>
              </el-col>
            </el-row>
          </el-form>
        </div>


        <div v-if="showForm" class="table-b">
          <div class="table-name">
            <h3 class="ico_table_name">{{ `정산비용` }}</h3>
          </div>
          <el-form v-if="showForm" size="mini" :model="form" ref="catInfoForm" class="components">
            <el-row>
              <el-col>
                <el-col :span="12">
                  <el-form-item label="설치비(1)">
                    <el-input v-model="form.squareSetupUnitPrice1" :disabled="disabledSquareSetupUnitPrice1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="설치비(2)">
                    <el-input v-model="form.squareSetupUnitPrice2" :disabled="disabledSquareSetupUnitPrice2" @input="squareSetupCalcAmt"></el-input>
                  </el-form-item>
                </el-col>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-col :span="12">
                  <el-form-item label="원거리출장비" prop="catNm">
                    <el-input v-model="form.squareSetupEtcPrice1" :disabled="disabledSquareSetupEtcPrice1" @input="squareSetupCalcAmt"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="기타비용" prop="catNm">
                    <el-input v-model="form.squareSetupEtcPrice2" :disabled="disabledSquareSetupEtcPrice2" @input="squareSetupCalcAmt"></el-input>
                  </el-form-item>
                </el-col>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-col :span="12">
                  <el-form-item label="합계" prop="catNm">
                    <el-input v-model="form.squareSetupAmt" :disabled="disabledSquareSetupAmt"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="정산년월" prop="catNm">
                    <el-date-picker type="month" placeholder="Pick a date" v-model="form.squareYymm" style="width: 100%;" value-format="yyyyMM" :disabled="disabledSquareYymm"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <div class="table-a">
          <el-row :gutter="6">
            <el-col>
              <el-button type="info" icon="el-icon-document" v-show="showButton" @click="modify">
                진행중
              </el-button>
              <el-button type="info" icon="el-icon-document" v-show="showButton" @click="success">
                설치완료
              </el-button>
              <el-button type="primary" icon="el-icon-folder-checked" v-show="showBtnApproval" @click="buttonClickEventAction('APPROVAL')">
                승인
              </el-button>
              <el-button type="danger" icon="el-icon-folder-checked" v-show="showBtnApprovalCancel" @click="buttonClickEventAction('APPROVALCANCEL')">
                승인취소
              </el-button>
              <el-button type="info" icon="el-icon-document" v-show="showBtnSquareCancel" @click="buttonClickEventAction('SQUARECANCEL')">
                정산취소
              </el-button>
              <el-button type="info" icon="el-icon-document" v-show="showBtnSquare" @click="buttonClickEventAction('SQUARE')">
                정산
              </el-button>
            </el-col>
          </el-row>
        </div>

      </div>
    </div>
  </layout>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import SelectCellRendererSecondary from "@/components/agGrid/select-cell-renderer-secondary";
import mixin from "@/mixin/lucoms";
import AgGridSearchBtn from "@/components/agGrid/AgGridSearchBtn";
import _ from "lodash";
import Layout from "@/components/Slot/ModalSlot";

function comma(val){
  return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default {
  name: "productInstallEditInfo",
  mixins: [mixin],
  components: {Layout},
  props: {
    data: {
      Type: Array
      , required: false
    },
  },
  data() {
    return {
      title: '설치내역',
      delData: [],
      mainData: [],
      subData: [],
      gridStyle : 'padding-top: 40px; width: 100%;height: 250px; min-height:100px;',
      columnDefs: [],
      subColumnDefs: [],
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      subGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      defaultColDef: {
        resizable: true
        , filter:false
        , sortable: true
      },
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        selectCellRenderer: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        schBtn : AgGridSearchBtn,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer,
        secondarySelect: SelectCellRendererSecondary,
      },
      /** modelSetupSelItem **/

      showButton : false,                      /** 버튼 표시 여부 **/
      showBtnModify : false,                   /** 진행중 버튼 표시 여부 **/
      showBtnSuccess : false,                  /** 설치완료 버튼 표시 여부 **/
      showBtnApproval : true,                 /** 승인 버튼 표시 여부 **/
      showBtnApprovalCancel : true,           /** 승인취소 버튼 표시 여부 **/
      showBtnSquareCancel  : true,            /** 정산취소 버튼 표시 여부 **/
      showBtnSquare : true,                   /** 정산 버튼 표시 여부 **/
      disabledSquareYymm : false,              /** 정산년월 disabled 여부 **/
      disabledSquareSetupUnitPrice1 : false,   /** 정산비용 설치비 disabled 여부 **/
      disabledSquareSetupUnitPrice2 : false,   /** 정산비용 설치비2 disabled 여부 **/
      disabledSquareSetupEtcPrice1 : false,    /** 정산비용 원거치출장비 disabled 여부 **/
      disabledSquareSetupEtcPrice2 : false,    /** 정산비용 기타비용 disabled 여부 **/
      disabledSquareSetupAmt : false,          /** 정산비용 합계 disabled 여부 **/

      form: {
        companyId : '',
        requestId : '',
        requestDt : '',          // 의뢰일자
        requestNm : '',          // 의뢰자
        requestSetupDt : '',     /**설치완료요청일**/
        siteId : '',
        siteType : '',           // 고객구분
        siteNm : '',
        siteNm1 : '',            // 사이트명1
        siteNm2 : '',            // 사이트명2
        siteNm3 : '',            // 사이트명3
        chargeNm : '',           // 고객명
        telNo : '',              // 전화번호
        hpNo : '',               // 휴대폰
        zipCd : '',
        addr : '',
        addr1 : '',              // 주소1
        addr2 : '',              // 주소2
        memo : '',               // 특기사항
        saleDeptNm : '',
        saleChargeNm : '',
        setupUnitPrice1 : '',
        setupUnitPrice2 : '',
        setupEtcPrice1 : '',
        setupEtcPrice2 : '',
        setupDt : '',
        setupAmt : '',
        procYn : '',
        confirmDt : '',
        confirmYn : '',
        squareYymm : '',
        squareSetupUnitPrice1 : 0,
        squareSetupUnitPrice2 : 0,
        squareSetupEtcPrice1 : 0,
        squareSetupEtcPrice2 : 0,
        squareSetupAmt : '',
        squareYn : '',
        asAgentId : '',          // 처리기사
        asAgentNm : '',
        setupResult : '',
        deleteYn : '',
        creatorId : '',
        creatorNm : '',
        createDt : '',
        updatorId : '',
        updatorNm : '',
        updateDt : '',
        agentUser : '0',

        siteTypeCombo : '',
        yearsCombo : '',
        monthsCombo : '',


        /** info **/
        modelSetupInfoId : '',
        modelGroup: '',          /** 모델그룹 */
        modelGroupNm: '',        /** 모델그룹명 */
        modelId: '',             /** 모델ID */
        modelCd : '',
        modelNm : '',            // 모델명
        maker: '',               /** 제조사 */
        makerNm: '',             /** 제조사명 */
        guaranteeStartDt : '',
        guaranteeEndDt : '',
        purchaseDt : '',
        prodDt : '',
        modelQty : '',           // 의뢰대수
        guaranteeMonth : '',

        type : '',
      },
      defForm: {
        modelSetupInfoId : '',
        modelGroup: '',          /** 모델그룹 */
        modelGroupNm: '',        /** 모델그룹명 */
        modelId: '',             /** 모델ID */
        modelCd : '',
        modelNm : '',            // 모델명
        maker: '',               /** 제조사 */
        makerNm: '',             /** 제조사명 */
        guaranteeStartDt : '',
        guaranteeEndDt : '',
        purchaseDt : '',
        prodDt : '',
        modelQty : '',           // 의뢰대수
        guaranteeMonth : '',
      },
      combos: {
        'catId' : [],
        'subCatId' : [],
        'procType' : [],
        'asAgentId' : [],
        'FRGN_CUR_CD' : [],
        'setupStatus' : [],
        'agentUser' : [],
      },
      statusBar: null,
      showForm : true,
      auth : ''
    };
  },
  methods: {
    setProductInstallEditInfo() {

      Object.assign(this.form, this.data.modelSetupSelItem1[0]);
      this.mainData = this.data.modelSetupSelItem2;
      this.subData = this.data.modelSetupSelItem3;

      // 처리기사, 지역센터 값 세팅
      this.setCatIdAndSubCatId(this.form.asAgentId);
      this.combos["years"] = this.form.yearsCombo;
      this.changeData();

      if(this.form.procYn == 'N' && this.form.confirmYn == 'N' && this.form.squareYn == 'N'){
        this.showButton = true;
      }

      // 승인
      if(this.form.procYn == 'N' || this.form.confirmYn == 'Y' || this.form.squareYn == 'Y' || this.form.type != "Approval") this.showBtnApproval = false;
      // 승인취소
      if(this.form.procYn == 'N' || this.form.confirmYn == 'N' || this.form.squareYn == 'Y' || this.form.type != "Approval") this.showBtnApprovalCancel = false;

      // 정산
      if(this.form.procYn == 'N' || this.form.confirmYn == 'N' || this.form.squareYn == 'Y' ||  this.form.type != "Square") this.showBtnSquare = false;
      // 정산취소
      if(this.form.procYn == 'N' || this.form.confirmYn == 'N' || this.form.squareYn == 'N' ||  this.form.type != "Square") this.showBtnSquareCancel = false;
      if(this.form.procYn == 'N' && this.form.confirmYn == 'Y' && this.form.squareYn == 'Y'){
        this.disabledSquareSetupUnitPrice1 = true;
        this.disabledSquareSetupUnitPrice2 = true;
        this.disabledSquareSetupEtcPrice1 = true;
        this.disabledSquareSetupEtcPrice2 = true;
        //this.disabledSquareSetupAmt = true;
      }
      //정산년월
      if(this.form.procYn == 'N' && this.form.confirmYn == 'N' && this.form.squareYn == 'Y') this.disabledSquareYymm = true;
      // 정산전까지는 콜센타가 아닌(센터)는 안보이도록 - AS-IS 그대로 구현.
      if(this.auth[0].grantExtend1 === 'N' && (this.form.procYn == 'N' || this.form.confirmYn == 'N' || this.form.squareYn == 'N')){
        this.showForm = false;
      }
    },
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;
      //this.getGuaranteeMonth();
      this.init();
    },
    closeModal() {
      this.$parent.close();
    },
    isEmpty(value){
      if( value == "" || value == null || value == undefined || value == 'undefined' || ( value != null && typeof value == "object" && !Object.keys(value).length ) ){
        return ""
      }else{
        return value
      }
    },
    async init() {
      // this.form.requestDt = this.$moment().format('YYYY-MM-DD') /** 당일 */
      // this.form.requestProcDt = this.$moment().format('YYYY-MM-DD') /** 당일 */
      this.form.addr = this.form.addr1 + ' ' + this.form.addr2;
      this.form.siteNm = this.isEmpty(this.form.siteNm1) + ' ' + this.isEmpty(this.form.siteNm2) + ' ' + this.isEmpty(this.form.siteNm3) ;

      this.$store.commit('loading');
      await this.$http.post(`/api/agent/InstallAgnet/init`)
          .then(response => {
            this.combos['setupStatus'] = response.data.setupStatus;
            this.combos['agentUser'] = response.data.agentUser;
          }).finally(() => {
            //this.goOpen();
            this.$store.commit('finish');
          });
      this.createMainColumnDefs();
    },
    createMainColumnDefs() {
      const vm = this;

      this.columnDefs = [
        {headerName:'순번', field:'modelSetupInfoId', width:120, editable : false},
        {headerName:'제품군', field:'modelGroupNm', width:140, editable : false},
        {headerName:'모델', field:'modelNm', width:140, editable : false},
        {headerName:'수량', field:'modelQty', width:120, cellStyle:{textAlign: 'right', backgroundColor: '#fff8f7'}, editable : false,
          valueFormatter: (params) => {
            return vm.getNumberFormat(params.value);
          }
        },
      ];

      this.subColumnDefs = [
        {headerName:'순번', field:'no', width:80, cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'제조사', field:'makerNm', width:140, editable : false},
        {headerName:'제품군', field:'modelGroupNm', width:140, editable : false},
        {headerName:'모델', field:'modelNm', width:200, editable : false},
        {headerName:'제조번호', field:'serialNo', width:200, editable : true, headerClass: 'require-column'},
        {headerName:'제조년월', field:'purchaseDt', width:140, editable : false, headerClass: 'require-column',
          cellRenderer: 'datePicker',
          valueFormatter: (params) => {
            return this.$moment(params.procDt).format('YYYY-MM-DD')
          }
        },
        {headerName:'특이사항', field:'description', cellStyle:{textAlign: 'left'}, width:250, editable : true, headerClass: 'require-column'},
        {headerName:'', field:'modelSetupInfoId', hide : true},
        {headerName:'', field:'modelSetupDetailId', hide : true},
      ];
    },
    getDateFormat(val) {
      if (val) {
        return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
      }
    },
    getCombo() {
      this.getCatIdCombo();
      this.getProcType();
    },
    getProcType(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 247} })
          .then(response => {
            this.combos['procType'] = response.data || []
          });
    },
    getCatIdCombo(){
      this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: 217} })
          .then(response => {
            this.combos['catId'] = response.data || []
          });
    },
    modify(){
      const vm = this;

      let subData = this.$refs.gridSub.rowData;
      let submitList = [];

      subData.forEach( x=>{
        submitList.push({
          modelSetupInfoId : x.modelSetupInfoId,
          modelSetupDetailId : x.modelSetupDetailId,
          prodDt : x.purchaseDt,
          serialNo : x.serialNo,
          description : x.description
        });
      });

      this.$store.commit('loading')
      this.$http.post("/api/agent/InstallAgnet/save", {
        companyId: this.$store.state.loginInfo.compCd,
        requestId: this.form.requestId,
        procYn: 'N',
        setupResult: this.form.setupResult == null ? '' : this.form.setupResult,
        userId: this.form.agentUser,
        updatorId: this.$store.state.loginInfo.id,
        processTime: "",
        modelSetupDetailList : submitList
      }).then(response => {
        this.$swal({ type: 'success', text: '수정 되었습니다.' });
        this.closeModal();
        vm.$parent.goOpen();
      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    success(){
      const vm = this;

      let subData = this.$refs.gridSub.rowData;
      let submitList = [];

      subData.forEach( x=>{
        submitList.push({
          modelSetupInfoId : x.modelSetupInfoId,
          modelSetupDetailId : x.modelSetupDetailId,
          prodDt : x.purchaseDt,
          serialNo : x.serialNo,
          description : x.description
        });
      });


      let chkedObj = subData.filter(x=>x.serialNo=='')

      if(chkedObj.length > 0){
        this.$swal({
          type: 'warning',
          text: '설치완료 하시려면 설치모델의 제조번호를 반드시 입력하셔야 합니다.'
        });

        return false
      }

      this.$store.commit('loading')
      this.$http.post("/api/agent/InstallAgnet/save", {
        companyId: this.$store.state.loginInfo.compCd,
        requestId: this.form.requestId,
        procYn: 'Y',
        setupResult: this.form.setupResult == null ? '' : this.form.setupResult,
        userId: this.form.agentUser,
        updatorId: this.$store.state.loginInfo.id,
        processTime: "",
        modelSetupDetailList : submitList
      }).then(response => {
        this.$swal({ type: 'success', text: '설치완료 되었습니다.' });
        this.closeModal();
        vm.$parent.goOpen();
      }).finally(() => {
        this.$store.commit('finish')
      });

    },
    onCatIdChange(param){
      this.form.subCatId = null;
      this.form.asAgentId = null;
      // 지역 상세
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: param} })
          .then(response => {
            this.combos['subCatId'] = response.data || []
          }).finally(() => {
      });
    },
    getSubCatIdChange(param){
      this.$store.commit('loading')
      this.form.asAgentId = null;

      this.$http.get(`/api/codeMng/detail/catId`, { params: {catId: param} })
          .then(response => {
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    //  그리드 데이터 선택 후 지역/센터 값 세팅
    setCatIdAndSubCatId(param){

      let valueSubCatId;
      this.$http.get(`/api/codeMng/detail`, { params: {catKey: param}})
          .then(response => {
            // 조회 한 지역/센터 값
            valueSubCatId = response.data.map(x => {
              x.key = x.parentId
              x.value = x.parentNm
              return x
            })

            // 지역 값 선택
            this.form.catId  = _.cloneDeep(this.combos['catId'].filter(x => parseInt(x.key) === parseInt(valueSubCatId[0].key))[0].key)

            // 지역 상세값 리스트 조회
            this.$http.get(`/api/codeMng/combo`, { params: {parentId: valueSubCatId[0].parentId} })
                .then(response => {
                  this.combos['subCatId'] = response.data || []
                  // 지역 상세값 선택
                  // this.form.subCatId  = _.cloneDeep(this.combos['subCatId'].filter(x => parseInt(x.key) === valueSubCatId[0].catId)[0].key)
                })
          })
    },
    dataClear(){
      this.form.companyId = ''
      this.form.requestId = ''          // 의뢰번호
      this.form.requestDt = ''          // 의뢰일자
      this.form.requestNm = ''          // 의뢰자
      this.form.siteType = ''           // 고객구분
      this.form.siteTypeNm = ''         // 고객구분명
      this.form.addr = ''
      this.form.addr1 = ''              // 주소1
      this.form.addr2 = ''              // 주소2
      this.form.chargeNm = ''           // 고객명
      this.form.telNo = ''              // 전화번호
      this.form.hpNo = ''               // 휴대폰
      this.form.modelNm = ''            // 모델
      this.form.modelQty = ''           // 의뢰대수
      this.form.requestProcDt = ''      // 처리요청일
      this.form.workDetails = ''        // 작업내용
      this.form.memo = ''               // 특기사항
      this.form.procUnitPrice1 = ''     // 처리비
      this.form.procUnitPrice2 = ''     // 단가
      this.form.procEtcPrice1 = ''      // 출장급지
      this.form.procEtcPrice2 = ''      // 기타비용
      this.form.catId = ''              // 지역
      this.form.subCatId = ''           // 지역상세
      this.form.sortType = ''           // 승인/정산처리유형
      this.form.siteNm = ''
      this.form.siteNm1 = ''            // 사이트명1
      this.form.siteNm2 = ''            // 사이트명2
      this.form.siteNm3 = ''            // 사이트명3
    },
    changeData(){
      //고객구분 코드 => 코드명 변경
      // let filterSiteType = this.form.siteTypeCombo.filter(x => x.key === this.form.siteType);
      // this.form.siteTypeNm = filterSiteType[0].value;

      this.form.setupUnitPrice1 = comma(this.form.setupUnitPrice1);  // 설치비(1)
      this.form.setupUnitPrice2 = comma(this.form.setupUnitPrice2);  // 설치비(2)
      this.form.setupEtcPrice1 = comma(this.form.setupEtcPrice1);    // 출장급지
      this.form.setupEtcPrice2 = comma(this.form.setupEtcPrice2);    // 기타비용

      this.form.squareSetupUnitPrice1 = comma(this.form.squareSetupUnitPrice1);    // 정산비용 설치비
      this.form.squareSetupUnitPrice2 = comma(this.form.squareSetupUnitPrice2);    // 정산비용 설치비(2)
      this.form.squareSetupEtcPrice1 = comma(this.form.squareSetupEtcPrice1);      // 정산비용 원거리출장비
      this.form.squareSetupEtcPrice2 = comma(this.form.squareSetupEtcPrice2);      // 정산비용 기타비용
      this.form.squareSetupAmt = comma(this.form.squareSetupAmt);                  // 정산비용 합계
    },
    updateRealItem(pVal){
      const that = this;
      const rowNode = this.mainGridOptions.api.getRowNode(this.rowId);
    },
    buttonClickEventAction(param){
      let vReturnMsg;

      if(!this.validation(param)) return false;

      let vform = {
        companyId: this.$store.state.loginInfo.compCd,
        requestId: this.form.requestId,
        squareSetupUnitPrice2 : this.removeCommas(this.form.squareSetupUnitPrice2),
        squareSetupEtcPrice1 : this.removeCommas(this.form.squareSetupEtcPrice1),
        squareSetupEtcPrice2 : this.removeCommas(this.form.squareSetupEtcPrice2),
        division : param,
      }

      if(param === 'APPROVAL' || param === 'APPROVALCANCEL' ){
        vform.confirmYn = param === 'APPROVAL' ? 'Y' : 'N'
      } else if (param === 'SQUARE' || param === 'SQUARECANCEL'){
        vform.squareYn = param === 'SQUARE' ? 'Y' : 'N'
        vform.squareYymm = this.form.squareYymm
      }

      if(['APPROVAL', 'SQUARE'].includes(param)){
        vReturnMsg = '완료되었습니다.'
      } else if (['APPROVALCANCEL', 'SQUARECANCEL'].includes(param)){
        vReturnMsg = '취소되었습니다.'
      }

      this.$store.commit('loading')
      this.$http.post("/api/workMng/approval/procSetUp", vform).then(response => {
        this.$swal({ type: 'success', text: vReturnMsg });
      }).finally(() => {
        this.$store.commit('finish')
        this.$parent.close();
        this.$parent.$parent.goOpen();
      });
    },
    validation(param) {
      // "MODIFY" 진행중
      // "SUCCESS" 설치완료
      if(["MODIFY", "SUCCESS"].includes(param)) {
        if(this.form.procYn === 'Y'){
          this.$swal({ type: 'warning', text: '설치완료된 설치건 입니다.' });
          return false;
        }
        if(this.form.confirmYn === 'Y'){
          this.$swal({ type: 'warning', text: '승인완료된 설치건 입니다.' });
          return false;
        }
        if(this.form.squareYn === 'Y'){
          this.$swal({ type: 'warning', text: '정산완료된 설치건 입니다.' });
          return false;
        }
        if(param === "SUCCESS") {
          // if(this.form.squareYn === 'Y'){
          //   this.$swal({ type: 'warning', text: '설치완료 하시려면 설치모델의 제조번호를 반드시 입력하셔야 합니다.' });
          // }
        }
      } else if(param === "APPROVAL"){
        // 승인
        if(this.form.procYn === 'N'){
          this.$swal({ type: 'warning', text: '설치완료된 설치건이 아닙니다.' });
          return false;
        }
        if(this.form.confirmYn === 'Y'){
          this.$swal({ type: 'warning', text: '승인완료된 설치건 입니다.' });
          return false;
        }
        if(this.form.squareYn === 'Y'){
          this.$swal({ type: 'warning', text: '정산완료된 설치건 입니다.' });
          return false;
        }
      } else if(param === "APPROVALCANCEL"){
        // 승인취소
        if(this.form.procYn === 'N'){
          this.$swal({ type: 'warning', text: '설치완료된 설치건이 아닙니다.' });
          return false;
        }
        if(this.form.confirmYn === 'N'){
          this.$swal({ type: 'warning', text: '승인완료된 설치건이 아닙니다.' });
          return false;
        }
        if(this.form.squareYn === 'Y'){
          this.$swal({ type: 'warning', text: '정산완료된 설치건 입니다.' });
          return false;
        }
      } else if(param === "SQUARE"){
        // 정산
        if(this.form.procYn === 'N'){
          this.$swal({ type: 'warning', text: '설치완료된 설치건이 아닙니다.' });
          return false;
        }
        if(this.form.confirmYn === 'N'){
          this.$swal({ type: 'warning', text: '승인완료된 설치건이 아닙니다.' });
          return false;
        }
        if(this.form.squareYn === 'Y'){
          this.$swal({ type: 'warning', text: '정산완료된 설치건 입니다.' });
          return false;
        }
        if(this.form.squareYymm.length < 5){
          this.$swal({ type: 'warning', text: '정산년월을 선택해주세요.' });
          return false;
        }
      } else if(param === "SQUARECANCEL") {
        // 정산취소
        if(this.form.procYn === 'N'){
          this.$swal({ type: 'warning', text: '설치완료된 설치건이 아닙니다.' });
          return false;
        }
        if(this.form.confirmYn === 'N'){
          this.$swal({ type: 'warning', text: '승인완료된 설치건이 아닙니다.' });
          return false;
        }
        if(this.form.squareYn === 'N'){
          this.$swal({ type: 'warning', text: '정산완료된 설치건이 아닙니다.' });
          return false;
        }
      }
      return true;
    },
    // 콤마를 제거하는 함수
    removeCommas(numberString) {
      return String(numberString).replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    },
    calculatedResult(inputValue1, inputValue2, inputValue3, inputValue4) {
      const number1 = parseInt(this.removeCommas(inputValue1));
      const number2 = parseInt(this.removeCommas(inputValue2));
      const number3 = parseInt(this.removeCommas(inputValue3));
      const number4 = parseInt(this.removeCommas(inputValue4));

      if (number1 !== null && number2 !== null && number3 !== null && number4 !== null) {
        return number1 + number2 + number3 + number4;
      } else {
        return null;
      }
    },
    squareSetupCalcAmt(param){
      if(param === ''){
        if(this.form.squareSetupUnitPrice2 === '') this.form.squareSetupUnitPrice2 = 0;
        if(this.form.squareSetupEtcPrice1 === '') this.form.squareSetupEtcPrice1 = 0;
        if(this.form.squareSetupEtcPrice2 === '') this.form.squareSetupEtcPrice2 = 0;
      }
      this.form.squareSetupAmt = this.calculatedResult(this.form.squareSetupUnitPrice1, this.form.squareSetupUnitPrice2, this.form.squareSetupEtcPrice1, this.form.squareSetupEtcPrice2);
    },
    isAuth(){
      this.auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===176); // 설치내역 팝업
      const auth = this.auth

      //todo 임시 주석처리 권한 처리 확인 필요 시작
       if(auth && auth.length > 0){
         //this.showBtnModify = auth[0].grantUpdate === 'Y' ? true : false;           // 진행중
         //this.showBtnSuccess = auth[0].grantExtend2 === 'Y' ? true : false;         // 설치완료
         this.showBtnApproval = auth[0].grantExtend3 === 'Y' ? true : false;        // 승인
         this.showBtnApprovalCancel = auth[0].grantExtend4 === 'Y' ? true : false;  // 승인취소
         this.showBtnSquareCancel = auth[0].grantExtend6 === 'Y' ? true : false;    // 정산취소
         this.showBtnSquare = auth[0].grantExtend5 === 'Y' ? true : false;          // 정산
         this.disabledSquareYymm = auth[0].grantExtend5 === 'Y' ? false : true;     // 정산년월
         this.disabledSquareSetupUnitPrice1 = (auth[0].grantExtend3 === 'N' && auth[0].grantExtend5 === 'N' ) ? true : false;   //정산비용 설치비
         this.disabledSquareSetupUnitPrice2 = (auth[0].grantExtend3 === 'N' && auth[0].grantExtend5 === 'N' ) ? true : false;   //정산비용 설치비2
         this.disabledSquareSetupEtcPrice1 = (auth[0].grantExtend3 === 'N' && auth[0].grantExtend5 === 'N' ) ? true : false;    //정산비용 원거리출장비
         this.disabledSquareSetupEtcPrice2 = (auth[0].grantExtend3 === 'N' && auth[0].grantExtend5 === 'N' ) ? true : false;    //정산비용 기타비용
         this.disabledSquareSetupAmt = (auth[0].grantExtend3 === 'N' && auth[0].grantExtend5 === 'N' ) ? true : false;          //정산비용 합계
       }
      //todo 임시 주석처리 권한 처리 확인 필요 종료
    }
  },
  mounted() {
    this.getCombo()
    this.isAuth();
    //pop slots modal move
    $(".animation-content").addClass('pop_min2');
    $(".animation-content").draggable({'cancel':'.modal-card-body'});
    //ModalSlot open z-index change
    $('.lnb').css('z-index', '4');

    this.setProductInstallEditInfo();
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  watch: {
    'form.asAgentId'(){
      this.form.subCatId = this.form.asAgentId;
    }
  }
}

</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 0;
  // &:last-child {
  //   margin-bottom: 0;
  // }
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px 0 0 10px;
  border-radius: 5px;
}
.el-form-item {
  margin-right: 10px;
  // &:last-child {
  //   margin-right: 0;
  // }
}
.large-textarea{
  padding: 0 24px !important
}
.el-select {
  width: 100%;
}
</style>